import BadgeGroupAtomic from 'components/atomic/organisms/badge-group';
import { ListingBadge, type BadgeVariant } from './listing-badge';
import type { BadgeData } from './use-badges';

export interface BadgeGroupProps {
  badges: BadgeData[];
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  maxBadges?: number;
  /** Distance from the anchored edges (e.g. '12px'). Defaults to the atomic 19px. */
  offset?: string;
}

export function BadgeGroup({
  badges,
  position = 'top-left',
  maxBadges = 2,
  offset,
}: BadgeGroupProps) {
  if (badges.length === 0) {
    return null;
  }

  const limitedBadges = badges.slice(0, maxBadges);

  const renderBadge = (badge: BadgeData, index: number) => {
    const key = `badge-${badge.type}-${index}`;

    return (
      <ListingBadge
        key={key}
        variant={badge.type as BadgeVariant}
        label={badge.label}
        textColor={badge.iconColor}
      />
    );
  };

  return (
    <BadgeGroupAtomic position={position} offset={offset}>
      {limitedBadges.map(renderBadge)}
    </BadgeGroupAtomic>
  );
}
